import * as Yup from 'yup';
import {
  type ReorderWeeks,
  reorderWeeks,
  type ThresholdWeeks,
  thresholdWeeks,
} from './order-settings';
import { type SaleStatDays, saleStatDays } from './product';

// form validation rules
export const OrderOptionsSchema = Yup.object().shape({
  qoh_threshold_weeks: Yup.mixed<ThresholdWeeks>().oneOf(thresholdWeeks).defined().required(),
  reorder_weeks: Yup.mixed<ReorderWeeks>().oneOf(reorderWeeks).defined().required(),

  send_methods: Yup.array().of(Yup.string().required()).required(),
  emails: Yup.array().of(Yup.string().email().required()).required(),

  // Deprecated
  qoh_threshold_percent: Yup.number().required(),
  sales_period_days: Yup.mixed<SaleStatDays>().oneOf(saleStatDays).defined().required(),
});

export type OrderOptions = Yup.InferType<typeof OrderOptionsSchema>;
